/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_FootnoteInputs */

const en_mk_sec_pg_ledger_footnote = /** @type {(inputs: Mk_Sec_Pg_Ledger_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We update this list when reality changes, not when a plan is made. If you find something elsewhere on the site that contradicts it, this list is the correct one — tell us and we will fix the other page.`)
};

const id_mk_sec_pg_ledger_footnote = /** @type {(inputs: Mk_Sec_Pg_Ledger_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar ini kami perbarui saat keadaannya berubah, bukan saat rencananya dibuat. Kalau Anda menemukan sesuatu di halaman lain yang bertentangan dengan daftar ini, daftar inilah yang benar — beri tahu kami dan halaman satunya yang akan kami perbaiki.`)
};

/**
* | output |
* | --- |
* | "We update this list when reality changes, not when a plan is made. If you find something elsewhere on the site that contradicts it, this list is the correct ..." |
*
* @param {Mk_Sec_Pg_Ledger_FootnoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_footnote = /** @type {((inputs?: Mk_Sec_Pg_Ledger_FootnoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_FootnoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_footnote(inputs)
	return en_mk_sec_pg_ledger_footnote(inputs)
});